/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum UserType {
  $0 = 0,
  $1 = 1,
  $2 = 2,
  $3 = 3
}
